var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6L2.57574 6.42426L2.15147 6L2.57574 5.57574L3 6ZM6.75 14.85C6.41863 14.85 6.15 14.5814 6.15 14.25C6.15 13.9186 6.41863 13.65 6.75 13.65L6.75 14.25L6.75 14.85ZM6.75 9.75L6.32574 10.1743L2.57574 6.42426L3 6L3.42426 5.57574L7.17426 9.32574L6.75 9.75ZM3 6L2.57574 5.57574L6.32574 1.82574L6.75 2.25L7.17426 2.67426L3.42426 6.42426L3 6ZM3 6L3 5.4L10.875 5.4L10.875 6L10.875 6.6L3 6.6L3 6ZM10.875 14.25L10.875 14.85L6.75 14.85L6.75 14.25L6.75 13.65L10.875 13.65L10.875 14.25ZM15 10.125L15.6 10.125C15.6 12.7345 13.4845 14.85 10.875 14.85L10.875 14.25L10.875 13.65C12.8218 13.65 14.4 12.0718 14.4 10.125L15 10.125ZM10.875 6L10.875 5.4C13.4845 5.4 15.6 7.51545 15.6 10.125L15 10.125L14.4 10.125C14.4 8.1782 12.8218 6.6 10.875 6.6L10.875 6Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoUnselected);
export default __webpack_public_path__ + "static/media/undo_unselected.3ae0a955d9653924969fe91df4cfc2e4.svg";
export { ForwardRef as ReactComponent };